// A gold refinery login (session `isRefinery`, oomero-be utils/refineryIndustry.js) works only in
// the refinery set-up (Ankit, 30 Sep 2026): the general workspace pages its menu does not offer
// open the matching refinery page instead. Oomero staff, superadmins and auditors are never limited.
// The screening profile pages, Create Profile and the onboarding pages they lead to stay open:
// the refinery pages link to them for KYC, screening and approval.
const truthy = (value) => value === true || value === 'true' || value === 1 || value === '1';

export const isRefineryLogin = (token) => {
    if (!token || !truthy(token.isRefinery ?? token.is_refinery)) return false;
    const roleName = String(token.roles?.role_name || token.role_name || '').toLowerCase();
    const staff = truthy(token.isSuperAdmin) || truthy(token.is_superadmin) || truthy(token.isOomero) || truthy(token.is_oomero);
    const auditor = truthy(token.isAuditor) || truthy(token.is_auditor) || roleName === 'auditor';
    return !staff && !auditor;
};

const INDIVIDUALS = '/refinery/clients?type=individual';
const REDIRECTS = [
    // Oomero Pulse
    [/^\/(dashboard)?$/, '/refinery'],
    // Screening and onboarded-profile lists (the profile pages themselves stay open)
    [/^\/(corporate_screening|view_corporate|screening|view_screening\/corporate_list|open-cases-by-company)\/?$/, '/refinery/clients'],
    [/^\/(individual_screening|view_individual_user|view_screening\/individual_list)\/?$/, INDIVIDUALS],
    // AML Check
    [/^\/(aml-check|aml_check|aml-check\/aml_details|aml\/search_results|aml\/search_data)\/?$/, '/refinery'],
    // Developer tools
    [/^\/(developer-api|developer_services|api-docs|crm-sdk|partners\/propspace)\/?$/, '/refinery'],
];

// Where a refinery login goes instead of `pathname`, or null when the page is open to it.
export const refineryRedirect = (pathname, token) => {
    if (!isRefineryLogin(token)) return null;
    const path = String(pathname || '/');
    const match = REDIRECTS.find(([pattern]) => pattern.test(path));
    return match ? match[1] : null;
};
